// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .edit-bar{
    min-width: auto;
    order: 2;
    min-height: auto; 
    height: max-content;
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;
    align-items: center;
    justify-content: center;
 
    background-color: rgb(0, 100, 128);


}
.student-EditHeading{
    margin-left: 40%;
    width: auto;
    height: auto;
    flex-grow: 1;
    font-family: "Open Sans";
    font-size: 50px;
    font-weight: 300;
    color: rgb(255, 255, 255);
    line-height: 1.3;
    border-radius: 0px;
} 
/* Style inputs, select elements and textareas */
 .editInput{
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
  } 
  
  /* Style the label to display next to the inputs */
    .StudentEditProfileLabel {
    padding: 12px 12px 12px 0;
    display: inline-block;
  }
   
  /* Style the submit button */
   .SubmitBtn {
    background-color: #04AA6D;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    float: right;
    width: 30%;
    /* margin-left: 30%; */
  }  
  
  /* Style the container */
   .StudentEditProfileContainer {
    border-radius: 5px;
    background-color: #f2f2f2;
    padding: 20px;
    width: 40%;
  }
    
  /* Floating column for labels: 25% width */
   .col-25 {
    float: left;
    width: 25%;
    margin-top: 6px;
    /* font-weight: bold; */
    font-size: 15px;
  }
    
  /* Floating column for inputs: 75% width */
    .col-75 {
    float: left;
    width: 75%;
    margin-top: 6px;
  }
  
  /* Clear floats after the columns */
    .row:after {
    content: "";
    display: table;
    clear: both;
  }  
  /* .row{
    display: flex;
    align-items: center;
    justify-content: center;
    width: -webkit-fill-available;
  } */
  
   /* // Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
  @media screen and (max-width: 600px) {
    .col-25, .col-75  {
      width: 100%;
      margin-top: 0;
    }
  } 
  @media screen and (max-width: 1000px) 
  {
    .StudentEditProfileContainer {
      width: 90%;
    }
    .student-EditHeading
    {
      text-align: center;
      margin-left: 0;
    }
  }
  /* Add this to your existing CSS or create a new CSS file */
/* .gender-container {
  display: flex;
  align-items: center;
} */
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/EditProfile.css"],"names":[],"mappings":"CAAC;IACG,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;IAEvB,kCAAkC;;;AAGtC;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA,gDAAgD;CAC/C;IACG,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,kDAAkD;IAChD;IACA,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA,4BAA4B;GAC3B;IACC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,sBAAsB;EACxB;;EAEA,wBAAwB;GACvB;IACC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,UAAU;EACZ;;EAEA,0CAA0C;GACzC;IACC,WAAW;IACX,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,eAAe;EACjB;;EAEA,0CAA0C;IACxC;IACA,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA,mCAAmC;IACjC;IACA,WAAW;IACX,cAAc;IACd,WAAW;EACb;EACA;;;;;KAKG;;GAEF,kJAAkJ;EACnJ;IACE;MACE,WAAW;MACX,aAAa;IACf;EACF;EACA;;IAEE;MACE,UAAU;IACZ;IACA;;MAEE,kBAAkB;MAClB,cAAc;IAChB;EACF;EACA,2DAA2D;AAC7D;;;GAGG","sourcesContent":[" .edit-bar{\n    min-width: auto;\n    order: 2;\n    min-height: auto; \n    height: max-content;\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 100%;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n \n    background-color: rgb(0, 100, 128);\n\n\n}\n.student-EditHeading{\n    margin-left: 40%;\n    width: auto;\n    height: auto;\n    flex-grow: 1;\n    font-family: \"Open Sans\";\n    font-size: 50px;\n    font-weight: 300;\n    color: rgb(255, 255, 255);\n    line-height: 1.3;\n    border-radius: 0px;\n} \n/* Style inputs, select elements and textareas */\n .editInput{\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n  } \n  \n  /* Style the label to display next to the inputs */\n    .StudentEditProfileLabel {\n    padding: 12px 12px 12px 0;\n    display: inline-block;\n  }\n   \n  /* Style the submit button */\n   .SubmitBtn {\n    background-color: #04AA6D;\n    color: white;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    float: right;\n    width: 30%;\n    /* margin-left: 30%; */\n  }  \n  \n  /* Style the container */\n   .StudentEditProfileContainer {\n    border-radius: 5px;\n    background-color: #f2f2f2;\n    padding: 20px;\n    width: 40%;\n  }\n    \n  /* Floating column for labels: 25% width */\n   .col-25 {\n    float: left;\n    width: 25%;\n    margin-top: 6px;\n    /* font-weight: bold; */\n    font-size: 15px;\n  }\n    \n  /* Floating column for inputs: 75% width */\n    .col-75 {\n    float: left;\n    width: 75%;\n    margin-top: 6px;\n  }\n  \n  /* Clear floats after the columns */\n    .row:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }  \n  /* .row{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: -webkit-fill-available;\n  } */\n  \n   /* // Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */\n  @media screen and (max-width: 600px) {\n    .col-25, .col-75  {\n      width: 100%;\n      margin-top: 0;\n    }\n  } \n  @media screen and (max-width: 1000px) \n  {\n    .StudentEditProfileContainer {\n      width: 90%;\n    }\n    .student-EditHeading\n    {\n      text-align: center;\n      margin-left: 0;\n    }\n  }\n  /* Add this to your existing CSS or create a new CSS file */\n/* .gender-container {\n  display: flex;\n  align-items: center;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
